import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddCategoryPayload,
  AddCategoryQuestionPayload,
  DeleteCategoryPayload,
  DeleteCategoryQuestionPayload,
  EditCategoryPayload,
  GetCategoriesPayload,
  GetCategoryPayload,
  IHelpCategory,
  IHelpLanguage,
  UpdateCategoriesOrderPayload,
  UpdateCategoryQuestionPayload,
} from '../types/market-help.type';

export const marketHelpApi = createApi({
  reducerPath: 'marketHelpApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/platform-settings/market-help`),
  endpoints: (builder) => ({
    getHelpLanguages: builder.query<ApiResponse<IHelpLanguage[]>, void>({
      query: () => ({
        url: '/languages',
        method: 'GET',
      }),
    }),
    getHelpCategories: builder.query<ApiResponse<IHelpCategory[]>, GetCategoriesPayload>({
      query: (payload) => ({
        url: '/categories',
        method: 'GET',
        params: payload,
      }),
    }),
    getHelpCategory: builder.query<ApiResponse<IHelpCategory>, GetCategoryPayload>({
      query: (payload) => ({
        url: `/categories/${payload.id}`,
        method: 'GET',
      }),
    }),
    addCategory: builder.mutation<ApiResponse<IHelpCategory>, AddCategoryPayload>({
      query: (payload) => ({
        url: '/categories',
        method: 'POST',
        body: payload,
      }),
    }),
    editCategory: builder.mutation<ApiResponse<IHelpCategory>, EditCategoryPayload>({
      query: (payload) => ({
        url: `/categories/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    deleteCategory: builder.mutation<void, DeleteCategoryPayload>({
      query: (payload) => ({
        url: `/categories/${payload.id}`,
        method: 'DELETE',
        body: payload,
      }),
    }),
    updateCategoriesOrder: builder.mutation<void, UpdateCategoriesOrderPayload>({
      query: (payload) => ({
        url: '/categories/order',
        method: 'PUT',
        body: payload,
      }),
    }),
    addCategoryQuestion: builder.mutation<ApiResponse<IHelpCategory>, AddCategoryQuestionPayload>({
      query: (payload) => ({
        url: `/categories/${payload.category_id}/questions`,
        method: 'POST',
        body: payload,
      }),
    }),
    updateCategoryQuestion: builder.mutation<ApiResponse<IHelpCategory>, UpdateCategoryQuestionPayload>({
      query: (payload) => ({
        url: `/categories/${payload.category_id}/questions/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    deleteCategoryQuestion: builder.mutation<void, DeleteCategoryQuestionPayload>({
      query: (payload) => ({
        url: `/categories/${payload.category_id}/questions/${payload.id}`,
        method: 'DELETE',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyGetHelpLanguagesQuery,
  useLazyGetHelpCategoriesQuery,
  useLazyGetHelpCategoryQuery,
  useAddCategoryMutation,
  useEditCategoryMutation,
  useDeleteCategoryMutation,
  useUpdateCategoriesOrderMutation,
  useAddCategoryQuestionMutation,
  useUpdateCategoryQuestionMutation,
  useDeleteCategoryQuestionMutation,
} = marketHelpApi;
